import { WORK_SCHEDULE_TYPES } from "@/constants/defaultValues";


let mockAttendanceDurations = [
  {
    id: 1,
    nameEnglish: 'Full Day',
    nameArabic: 'دوام كامل',
    code: 'FULLDAY',
    color: '#f0f9ff',
    workscheduletype: WORK_SCHEDULE_TYPES.WITH_TIME,
    flexStartTime: '08:00',
    flexEndTime: '18:00',
    coreStartTime: '09:30',
    coreEndTime: '15:00',
  },
  {
    id: 2,
    nameEnglish: 'Half Day',
    nameArabic: 'نصف يوم',
    code: 'HALFDAY',
    color: '#198754',
    workscheduletype: WORK_SCHEDULE_TYPES.WITH_TIME,
    flexStartTime: '09:00',
    flexEndTime: '13:00',
    coreStartTime: '09:30',
    coreEndTime: '12:00',
  },
  {
    id: 3,
    nameEnglish: 'Short Leave',
    nameArabic: 'إجازة قصيرة',
    code: 'SHORTLV',
    color: '#dc3545',
    workscheduletype: WORK_SCHEDULE_TYPES.WITH_TIME,
    flexStartTime: '09:00',
    flexEndTime: '13:00',
    coreStartTime: '09:30',
    coreEndTime: '11:30',
  },
  // New Records
  {
    id: 4,
    nameEnglish: 'Full Day',
    nameArabic: 'دوام كامل',
    code: 'FULLDAY',
    color: '#f0f9ff',
    workscheduletype: WORK_SCHEDULE_TYPES.FIXED_SCHEDULE,
    flexStartTime: '08:00',
    flexEndTime: '18:00',
    coreStartTime: '09:30',
    coreEndTime: '15:00',
  },
];

let idCounter = 4;

const AttendanceDurationAPI = {
  getAll: async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        // resolve({ data: { data: [...mockAttendanceDurations].reverse() } });
        resolve({ data: { data: [...mockAttendanceDurations] } });
      }, 300);
    });
  },

  add: async (newData) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const newItem = { ...newData, id: idCounter++ };
        mockAttendanceDurations = [...mockAttendanceDurations, newItem];
        resolve({ data: { data: newItem } });
      }, 300);
    });
  },

  update: async (id, updatedData) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const index = mockAttendanceDurations.findIndex(
          (item) => item.id === id
        );
        if (index !== -1) {
          mockAttendanceDurations[index] = {
            ...mockAttendanceDurations[index],
            ...updatedData,
          };
          resolve({ data: { data: mockAttendanceDurations[index] } });
        }
      }, 300);
    });
  },

  delete: async (ids) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const idsToDelete = Array.isArray(ids) ? ids : [ids];

        const initialLength = mockAttendanceDurations.length;
        mockAttendanceDurations = mockAttendanceDurations.filter(
          (item) => !idsToDelete.includes(item.id)
        );


        resolve({
          status: 200,
          data: {
            deletedCount: idsToDelete.length,
            deletedIds: idsToDelete,
          },
        });
      }, 300);
    });
  },
};

export default AttendanceDurationAPI;
